import { Text, UnstyledButton } from "@mantine/core";
import { IconRefresh } from "@tabler/icons-react";

import styles from "./DynamicToneGuidance.module.css";

interface TryAgainButtonProps {
    onClick: () => void;
}

export const TryAgainButton = ({ onClick }: TryAgainButtonProps) => (
    <UnstyledButton className={styles.tryAgainButton} onClick={onClick}>
        <IconRefresh size={14} />
        <Text size="sm">Show latest</Text>
    </UnstyledButton>
);
